import { InsuranceClearanceCertificateApplicationsDTO } from '@components/InsuranceClearanceCertification/models/InsuranceClearanceCertification.model';
import { createSlice } from '@reduxjs/toolkit';
import { PageableDTO } from '@shared/models/PageableDTO.model';

interface InsuranceClearanceCertificateListState {
  data: PageableDTO<InsuranceClearanceCertificateApplicationsDTO>;
  loading: boolean;
  error: string | null;
}

const initialState: InsuranceClearanceCertificateListState = {
  data: {
    content: [],
    meta: {
      total: 0,
      pageSize: 0,
      page: 0
    }
  },
  loading: true,
  error: null
};

const insuranceClearanceCertificateSlice = createSlice({
  name: 'insuranceClearanceCertificate',
  initialState,
  reducers: {
    setInsuranceClearanceCertificateList: (state, action) => {
      state.data = action.payload.data;
      state.loading = action.payload.loading;
      state.error = action.payload.error;
    },
    updateInsuranceClearanceCertificateItems: (state, action) => {
      const updatedItems = action.payload;

      state.data.content = state.data.content.map((item) => {
        const updated = updatedItems.find(
          (u: InsuranceClearanceCertificateApplicationsDTO) => u.appNum === item.appNum
        );
        return updated ? { ...item, ...updated } : item;
      });
    }
  }
});

export const InsuranceClearanceCertificateActions = insuranceClearanceCertificateSlice.actions;

export const InsuranceClearanceCertificateReducer = insuranceClearanceCertificateSlice.reducer;
